import { db } from '../../firebaseConfig';
import { getDocs, collection, query, where, orderBy, endBefore, limitToLast } from 'firebase/firestore/lite';


export const searchPrevDocuments = async (collectionName, searchFilters, searchLimit, firstVisible, sortOrderKey, sortOrderDirection) => {
  const collectionRef = collection(db, collectionName);
  let q;
  let orderByFilter;
  let isPrevAvailable = false;

  if(!validateInputs(collectionName, searchFilters, searchLimit, firstVisible)) {
    return;
  }
  // Parse Inputs
  const queryFilters = searchFilters.map((searchFilter) => where(searchFilter.key,'==',searchFilter.inputValue));
  if (sortOrderKey) {
    orderByFilter = orderBy(sortOrderKey, "asc");
    if (sortOrderDirection) {
      orderByFilter = orderBy(sortOrderKey, sortOrderDirection);
    }
  }
  // Generate Query
  if (orderByFilter) {
    q = query(collectionRef,
      ...queryFilters,
      orderByFilter,
      endBefore(firstVisible),
      limitToLast(searchLimit));
  } else {
    q = query(collectionRef,
      ...queryFilters,
      endBefore(firstVisible),
      limitToLast(searchLimit));
  }

  let docsSnapshot;
  try {
    docsSnapshot = await getDocs(q);
  } catch (error) {
    alert (`DB error encountered: ${error}`);
    console.log(error);
    return;
  }

  const tempList = [];
  docsSnapshot.forEach((doc) => {
    if (doc) {
      tempList.push(doc.data());
    }
  });

  const parsedDocs = tempList;
  const firstVisibleDocument = docsSnapshot.docs[0];
  const lastVisibleDocument = docsSnapshot.docs[docsSnapshot.docs.length-1];

  // Check if there are previous documents for previous button enablement
  let prevq;
  if (orderByFilter) {
    prevq = query(collectionRef,
      ...queryFilters,
      orderByFilter,
      endBefore(firstVisibleDocument),
      limitToLast(searchLimit));
  } else {
    prevq = query(collectionRef,
      ...queryFilters,
      endBefore(firstVisibleDocument),
      limitToLast(searchLimit));
  }

  let docsSnapshotPrevAhead;
  try {
    docsSnapshotPrevAhead = await getDocs(prevq);
  } catch (error) {
    alert (`DB error encountered: ${error}`);
    console.log(error);
    return;
  }

  if (docsSnapshotPrevAhead.docs.length < 1) {
    isPrevAvailable = false;
  } else {
    isPrevAvailable = true;
  }

  return ({
    docs: parsedDocs,
    firstVisibleDocument: firstVisibleDocument,
    lastVisibleDocument: lastVisibleDocument,
    isPrevAvailable: isPrevAvailable,
    isNextAvailable: true
  })
};

function validateInputs(collectionName, searchFilters, searchLimit, firstVisible) {
  if (!collectionName || !searchFilters || !searchLimit || !firstVisible) {
    alert('Incomplete database search parameters.');
    return false;
  }
  return true;
}
